var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item",class:{
    active: _vm.isActive,
    disabled: _vm.item.disabled,
  }},[_c('b-link',_vm._b({staticClass:"d-flex align-items-center"},'b-link',_vm.linkProps,false),[_c(_vm.item.icon,{tag:"component",staticStyle:{"height":"24px","width":"24px"}}),_c('span',{staticClass:"menu-title text-truncate"},[_vm._v(_vm._s(_vm.item.title))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }